import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, HelpCircle, MessageCircleQuestion, ChevronRight, Headphones } from 'lucide-react';

export default function FaqPage() {
  const navigate = useNavigate();

  const faqs = [
    {
      q: "Sản phẩm tại JapanICHIBA có chính hãng 100% từ Nhật Bản không?",
      a: "Tất cả sản phẩm tại hệ thống đều có hóa đơn mua hàng trực tiếp tại các store/mall uy tín tại Tokyo, Osaka và cam kết chính hãng 100%."
    },
    {
      q: "Thời gian giao hàng trung bình mất bao lâu?",
      a: "Đối với hàng có sẵn tại kho Việt Nam, thời gian giao từ 2-4 ngày. Đối với hàng Order trực tiếp từ Nhật Bản, thời gian vận chuyển từ 7-12 ngày làm việc."
    },
    {
      q: "Tôi có được kiểm tra hàng trước khi thanh toán không?",
      a: "Quý khách hoàn toàn được quyền mở bưu kiện kiểm tra ngoại quan sản phẩm trước khi thanh toán tiền mặt (COD) cho nhân viên giao hàng."
    },
    {
      q: "Làm thế nào để liên hệ bộ phận CSKH khi cần hỗ trợ khẩn cấp?",
      a: "Bạn có thể gọi trực tiếp hotline tổng đài hoặc nhắn tin qua khung chat trực tuyến trên website, đội ngũ tư vấn viên luôn túc trực hỗ trợ 24/7."
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 via-slate-50/50 to-white py-12 px-4 sm:px-6 relative overflow-hidden">
      <div className="absolute top-10 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-amber-500/5 blur-[120px] pointer-events-none rounded-full"></div>

      <div className="max-w-4xl mx-auto space-y-6 relative z-10">
        <div>
          <button
            onClick={() => navigate("/")}
            className="group inline-flex items-center gap-2.5 text-xs font-bold text-slate-600 hover:text-amber-600 bg-white hover:bg-amber-50/50 border border-slate-200/80 px-4 py-2.5 rounded-2xl transition-all duration-200 shadow-sm hover:shadow cursor-pointer"
          >
            <ArrowLeft className="w-4 h-4 transition-transform group-hover:-translate-x-1" /> 
            <span>Quay lại</span>
          </button>
        </div>

        <div className="bg-white/95 backdrop-blur-xl border border-slate-200/80 rounded-3xl p-8 sm:p-12 space-y-8 shadow-2xl shadow-slate-200/50">
          
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-slate-100 pb-6">
            <div className="flex items-center space-x-4">
              <div className="w-16 h-16 bg-amber-50 text-amber-600 rounded-2xl flex items-center justify-center shrink-0 shadow-inner">
                <HelpCircle className="w-8 h-8" />
              </div>
              <div>
                <span className="text-[11px] font-bold uppercase tracking-widest text-amber-600 bg-amber-50 px-2.5 py-1 rounded-full">
                  Trung tâm trợ giúp
                </span>
                <h1 className="text-2xl sm:text-3xl font-extrabold text-slate-900 font-serif mt-1.5">
                  Câu Hỏi Thường Gặp (FAQs)
                </h1>
              </div>
            </div>
            <div className="text-slate-400 text-xs flex items-center gap-1.5 self-start sm:self-center">
              <Headphones className="w-3.5 h-3.5 text-amber-500" /> Hỗ trợ 24/7
            </div>
          </div>

          <div className="bg-gradient-to-r from-amber-50/60 to-slate-50 border border-amber-100/60 p-5 sm:p-6 rounded-2xl text-slate-700 leading-relaxed text-xs sm:text-sm font-medium">
            Tổng hợp các thắc mắc phổ biến nhất từ khách hàng khi mua sắm các sản phẩm chính hãng Nhật Bản tại <strong className="text-amber-600">JapanICHIBA</strong>.
          </div>

          <div className="space-y-4 text-xs sm:text-sm">
            {faqs.map((item, idx) => (
              <div key={idx} className="bg-slate-50/80 border border-slate-200/60 p-5 rounded-2xl space-y-2 transition-all duration-200 hover:border-amber-200 hover:shadow-sm">
                <h3 className="font-bold text-slate-900 text-sm sm:text-base flex items-start gap-2.5">
                  <MessageCircleQuestion className="w-5 h-5 text-amber-600 shrink-0 mt-0.5" />
                  <span>{item.q}</span>
                </h3>
                <p className="text-slate-600 pl-7 leading-relaxed">
                  {item.a}
                </p>
              </div>
            ))}
          </div>

        </div>
      </div>
    </div>
  );
}